import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clientes from './pages/Clientes';
import Equipamentos from './pages/Equipamentos';
import Linhas from './pages/Linhas';
import Targets from './pages/Targets';
import CadastroRapido from './pages/CadastroRapido';
import Relatorios from './pages/Relatorios';
import Logins from './pages/Logins';
import Financeiro from './pages/Financeiro';
import MinhasCobrancas from './pages/MinhasCobrancas';
import Alertas from './pages/Alertas';
import Configuracoes from './pages/Configuracoes';
import Sugestoes from './pages/Sugestoes';
import Estatisticas from './pages/Estatisticas';
import CompartilharPublico from './pages/CompartilharPublico';
import Manutencoes from './pages/Manutencoes';
import Instalador from './pages/Instalador';
import RedefinirSenha from './pages/RedefinirSenha';
import Contratos from './pages/Contratos';
import AssinarContrato from './pages/AssinarContrato';
import Parceiros from './pages/Parceiros';
import Auditoria from './pages/Auditoria';

function App() {
  const token = localStorage.getItem('token');
  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}');
  const isCliente = usuario.perfil === 'cliente';
  const isSuperadmin = usuario.perfil === 'superadmin';
  const isInstalador = !isCliente;

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/redefinir-senha" element={<RedefinirSenha />} />
        <Route path="/assinar-contrato/:token" element={<AssinarContrato />} />
        <Route path="/dashboard" element={token ? <Dashboard /> : <Navigate to="/login" />} />
        <Route path="/clientes" element={token && !isCliente ? <Clientes /> : <Navigate to={token ? "/dashboard" : "/login"} />} />
        <Route path="/equipamentos" element={token && !isCliente ? <Equipamentos /> : <Navigate to={token ? "/dashboard" : "/login"} />} />
        <Route path="/linhas" element={token && !isCliente ? <Linhas /> : <Navigate to={token ? "/dashboard" : "/login"} />} />
        <Route path="/targets" element={token && !isCliente ? <Targets /> : <Navigate to={token ? "/dashboard" : "/login"} />} />
        <Route path="/cadastro-rapido" element={token && !isCliente ? <CadastroRapido /> : <Navigate to={token ? "/dashboard" : "/login"} />} />
        <Route path="/relatorios" element={token && !isCliente ? <Relatorios /> : <Navigate to={token ? "/dashboard" : "/login"} />} />
        <Route path="/auditoria" element={token && !isCliente ? <Auditoria /> : <Navigate to={token ? "/dashboard" : "/login"} />} />
        <Route path="/logins" element={token && !isCliente ? <Logins /> : <Navigate to={token ? "/dashboard" : "/login"} />} />
        <Route path="/financeiro" element={token && !isCliente ? <Financeiro /> : <Navigate to={token ? "/dashboard" : "/login"} />} />
        <Route path="/alertas" element={token ? <Alertas /> : <Navigate to="/login" />} />
        <Route path="/configuracoes" element={token && !isCliente ? <Configuracoes /> : <Navigate to={token ? "/dashboard" : "/login"} />} />
        <Route path="/sugestoes" element={token ? <Sugestoes /> : <Navigate to="/login" />} />
        <Route path="/estatisticas" element={token && !isCliente ? <Estatisticas /> : <Navigate to={token ? "/dashboard" : "/login"} />} />
        <Route path="/minhas-cobrancas" element={token ? <MinhasCobrancas /> : <Navigate to="/login" />} />
        <Route path="/compartilhar/:token" element={<CompartilharPublico />} />
        <Route path="/manutencoes" element={token ? <Manutencoes /> : <Navigate to="/login" />} />
        <Route path="/instalador" element={token && isInstalador ? <Instalador /> : <Navigate to={token ? "/dashboard" : "/login"} />} />
        <Route path="/contratos" element={token && !isCliente ? <Contratos /> : <Navigate to={token ? "/dashboard" : "/login"} />} />
        <Route path="/parceiros" element={token && isSuperadmin ? <Parceiros /> : <Navigate to={token ? "/dashboard" : "/login"} />} />
        <Route path="/" element={<Navigate to={token ? "/dashboard" : "/login"} />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;